export default __webpack_public_path__ + "static/media/barkanHotMethodImg.d05cc249.jpg";